import React from "react";

const TableHeader = (props) => {

    const { entidadInstancia, propiedadesHeaderGrilla } = props;

    //Se toma la primer entidadInstanciaId para obtener solo el primer grupo de instancias 
    //y poder desplegar una sola vez los campos con VISIBLEENGRILLAENTIDAD == 1
    let primerEntidadInstanciaId = entidadInstancia && entidadInstancia.length > 0 && entidadInstancia[0].EntidadInstanciaId

    let entidadInstanciaHeader = primerEntidadInstanciaId ? entidadInstancia.filter(instancia => instancia.VISIBLEENGRILLAENTIDAD && instancia.EntidadInstanciaId == primerEntidadInstanciaId) : propiedadesHeaderGrilla;
    let percentage = 100 / entidadInstanciaHeader.length;
    let stylePercentage = `${percentage}%`

    return (
        <thead>
            <tr>
                {entidadInstanciaHeader.map(instancia => {
                    return (
                        <th className="atlas_entidadInstanciaHeader" key={instancia.Id} 
                        style={{width: stylePercentage }}>
                            {instancia.Descripcion}
                        </th>
                    )
                })}
                <th className={""}></th>
            </tr>
        </thead>
    );
};

export default TableHeader